import * as yup from "yup";
import { PremiumReceivablesAgentRecord } from "entities/UIModel/PremiumReceivablesAgentRecord";

export const req = (label: string) => `${label} *`;

export const toAgentOptions = (agents: PremiumReceivablesAgentRecord[]) =>
  agents.map((a) => ({
    value: a.agentID,
    text: `${a.agentID} - ${a.name}`,
  }));

export const PERIOD_FORMAT_ERROR = "Must be MM/YYYY";
export const PERIOD_REGEX = /^(0[1-9]|1[0-2])\/\d{4}$/;

export const YEAR_MONTH_FORMAT_ERROR = "Must be YYYY/MM";
export const YEAR_MONTH_REGEX = /^\d{4}\/(0[1-9]|1[0-2])$/;

export const splitYearMonth = (yyyyMM: string) => {
  const [year, month] = yyyyMM.split("/");
  return { year, month };
};

export const toAccountingPeriod = (yyyyMM: string) => yyyyMM.replace("/", "");

export const toYearMonthDay = (date: Date) => {
  const year = String(date.getFullYear());
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}${month}${day}`;
};

export const toFirstOfMonthISO = (yyyyMM: string) => {
  const { year, month } = splitYearMonth(yyyyMM);
  return `${year}-${month}-01T00:00:00.000`;
};

export const COMMENTS_MAX_LENGTH = 200;
export const COMMENTS_MAX_ERROR = `Comments cannot exceed ${COMMENTS_MAX_LENGTH} characters`;

export const commentsField = () =>
  yup.string().nullable().max(COMMENTS_MAX_LENGTH, COMMENTS_MAX_ERROR);

export const getCommentsError = (
  value: string | null | undefined,
  error?: string,
) => ((value ?? "").length > COMMENTS_MAX_LENGTH ? COMMENTS_MAX_ERROR : error);

// The pricing input reports a cleared field as NaN rather than empty, which
// yup.number() treats as a type error even on optional fields. Coerce that
// (and "") to undefined so clearing a field is "no value", not "not a number".
export const numberField = () =>
  yup
    .number()
    .transform((value, originalValue) =>
      originalValue === "" || Number.isNaN(value) ? undefined : value,
    )
    .typeError("Must be a number");
